
import { Experiment_APIService } from "@/services/Experiment_APIService";
const apiService = new Experiment_APIService(process.env.VUE_APP_BASE_URL);
export default {
    data: () => ({
        camera_dialog: false,
        camera_dialog_camera: {},
        setup_dialog: false,
    }),
    methods: {
        popCamera(camera){
          this.camera_dialog = true;
          this.camera_dialog_camera = camera;
        },
        popSetup() {
            this.setup_dialog = true;
        },
      
        getValue(device_id, callback) {
            var self = this;
            apiService
            .getValue(
                self.$cookies.get("session_token"),
                self.$cookies.get("role"),
                self.experiment_name,
                self.$cookies.get("equipment_id"),
                device_id
            )
            .then((response) => {
                self.api.value_got_at = response.value_got_at;
                self.api.value_set_at = response.value_set_at;
                self.api.command_got_at = response.command_got_at;
                self.api.command_set_at = response.command_set_at;
                if(response.value!=''){
                    self.api.value = JSON.parse(response.value);
                }
                if (callback) {
                callback();
                }
            });
        },        
        getChart(device_id) {
            var self = this;
            apiService
            .getChart(
                self.$cookies.get("session_token"),
                self.$cookies.get("role"),
                self.experiment_name,
                self.$cookies.get("equipment_id"),
                device_id
            )
            .then((response) => {
                self.api.chart = response;
                self.series = [{ data: response }];
                console.log("self.series");
                console.log(self.series);
                self.loading = false;
            });
        },
        setCommand(device_id, command, callback) {
            var self = this;
            apiService
            .setCommand(
                self.$cookies.get("session_token"),
                self.$cookies.get("role"),
                self.experiment_name,
                self.$cookies.get("equipment_id"),
                device_id,
                command
            )
            .then(() => {
                if (callback) {
                callback();
                }
            });
        },
        requestChart(device) {
            var self = this;
            self.loading = true;
            self.setCommand(device, "MEASURE|START", function () {
            self.inte = setInterval(function () {
                self.getValue(device, function () {
                if (self.api.value.chart_at >= self.api.command_set_at) {
                    clearInterval(self.inte);
                    self.getChart(device);
                }
                });
            }, 4000);
            });
        },
        requestEngineeringChart(device, command) {
            var self = this;
            self.loading = true;
            self.setCommand(device, command, function () {
            self.inte = setInterval(function () {
                self.getValue(device, function () {
                if (self.api.value.chart_at >= self.api.command_set_at) {
                    clearInterval(self.inte);
                    self.getChart(device);
                }
                });
            }, 4000);
            });
        },
        setSCANCommand(device, command) {
            var self = this;
            self.moving = true;
            self.setCommand(device, command, function () {
                self.inte = setInterval(function () {
                    self.getValue(device, function () {
                        if (self.api.value_set_at >= self.api.command_set_at) {
                            clearInterval(self.inte);
                            self.moving = false;
                        }
                    });
                }, 500);
            });
        },
        requestSCAN(device,command) {
            var self = this;
            self.loading = true;
            self.setCommand(device, command, function () {
                self.inte = setInterval(function () {
                    self.getValue(device, function () {
                    if (self.api.value.chart_at >= self.api.command_set_at) {
                        clearInterval(self.inte);
                        self.getChart(device);
                    }
                    });
                }, 4000);
            });
        },
        requestIGraph(device, command) {
            var self = this;
            self.loading = true;
            self.showScanResult = false;
            self.setCommand(device, command, function () {
                self.inte = setInterval(function () {
                    self.getValue(device, function () {
                        if (self.api.value.chart_at >= self.api.command_set_at) {
                            clearInterval(self.inte);
                            self.loading = false;
                            self.showScanResult = true;
                            self.position = self.api.value.position;
                        }
                    });
                }, 4000);
                
            });

        },
        boardGetValue(device_id, callback) {
            var self = this;
            apiService
            .boardGetValue(
                self.experiment_name,
                self.equipment_id,
                device_id
            )
            .then((response) => {                
                self.api.value_got_at = response.value_got_at;
                self.api.value_set_at = response.value_set_at;
                self.api.command_got_at = response.command_got_at;
                self.api.command_set_at = response.command_set_at;
                if(response.value!=''){
                    self.api.value = JSON.parse(response.value);
                }
                if (callback) {
                callback();
                }
            });
        },
        boardGetChart(device_id, data) {
            var self = this;
            apiService
            .boardGetChart(
                self.experiment_name,
                self.equipment_id,
                device_id,
                data
            )
            .then((response) => {
                self.series[(parseInt(data)-1)].data = response;

                self.$refs.realtimeChart.updateSeries(self.series, false, true);
            });
        },
        boardGetChartFileLine(device_id, data) {
            var self = this;
            apiService
            .boardGetChartFileLine(
                self.experiment_name,
                self.equipment_id,
                device_id,
                data
            )
            .then((response) => {
                self.timer = parseInt(response)-1;
            });
        },
        boardSetChart(device_id, equipment_id, data, chart) {
            var self = this;
            apiService
            .boardSetChart(
                self.experiment_name,
                self.$cookies.get("equipment_id"),
                device_id,
                temp,
                chart
            )
            .then((response) => {
                console.log(response);
            });
        },
        readDataFromFile(device_id) {
            var self = this;
            apiService
            .readDataFromFile(
                self.experiment_name,
                self.$cookies.get("equipment_id"),
                device_id
            )
            .then((response) => {
//                self.api.chart = response;
                self.api.records = response;
            });
        },
        setDataToFile(records, device_id) {
            var self = this;
            apiService
            .setDataToFile(
                self.experiment_name,
                self.$cookies.get("equipment_id"),
                device_id,
                records
            )
            .then((response) => {
//                self.api.chart = response;
            });
        },
        
        getBoardFilename(device_id, data) {
            var self = this;
            apiService
            .getBoardFilename(
                self.experiment_name,
                self.equipment_id,
            )
            .then((response) => {
                window.open(
                    process.env.VUE_APP_BASE_URL +
                    "/api/experiment/" +
                    response.filename
                );
            });
        },

        getBoardPhotoName(experiment, equipment_id, light) {
            var self = this;
            apiService
            .getBoardPhotoName(
                experiment,
                equipment_id,
                light
            )
            .then((response) => {
//                return  process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
                self.img_src[light] = process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
                if(response.filename!=null){
                    self.api.img_src = process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;                    
                    if(equipment_id=='set_0'){
                        self.api.img_src_0[light] = process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
                    }
                    else if(equipment_id=='set_1'){
                        self.api.img_src_1[light] = process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
                    }
                    else if(equipment_id=='set_2'){
                        self.api.img_src_2[light] = process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
                    }
                    else if(equipment_id=='set_3'){
                        self.api.img_src_3[light] = process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
                    }
                }
            });
        },        
        requestIGraphResult(device, command) {
            var self = this;
            self.loading = true;
            self.showScanResult = false;
            self.setCommand(device, command, function () {
                self.inte = setInterval(function () {
                    self.getValue(device, function () {
                        if (self.api.value.chart_at >= self.api.command_set_at) {                            
                            clearInterval(self.inte);
                            self.loading = false;
                            self.showScanResult = true;
                            self.position = self.api.value.position;
                            self.getIGraphName();
                        }
                    });
                }, 4000);
                
            });

        },
        getIGraphName() {
            var self = this;            
            apiService
            .getIGraphName(
                self.experiment_name,
                self.$cookies.get("equipment_id"),
            )
            .then((response) => {
//                return  process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;
                self.img_src = process.env.VUE_APP_BASE_URL + "/api/experiment/" + response.filename;

            });
        },
    },
    created(){
    }
  }